<template>
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 6.14671C0.5 10.2119 4.04849 14.199 9.40046 17.6695C9.57594 17.7768 9.81965 17.884 9.99513 17.884C10.1706 17.884 10.4143 17.7768 10.5995 17.6695C15.9515 14.199 19.5 10.2119 19.5 6.14671C19.5 2.81269 17.1993 0.434036 14.1285 0.434036C12.364 0.434036 10.8335 1.34066 9.99513 2.74445C9.1665 1.3504 7.62622 0.434036 5.86172 0.434036C2.79092 0.434036 0.5 2.81269 0.5 6.14671Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "AppFavoriteIcon",
};
</script>
